import Navbar from 'components/Navbar'

const Signup = () => {
  return (
    <div className="w-full min-h-screen relative bg-light-primary text-black">
      <Navbar />
      <h1>Signup page</h1>
    </div>
  )
}

export default Signup
